export enum ActionConstants {
	SET_PROFILE_VERIFY_DATA = 'profile_set_verify_data',
}
